<template>
  <BaseCustomizeMetal componentCode="V" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalV",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 136px;
    left: 118px;
    @include betweenTableTablePro {
      top: 98px;
      left: 68px;
    }
    @include table {
      top: 80px;
      left: 43px;
    }
    @include phone {
      top: 66px;
      left: 29px;
    }
  }
  .templeName {
    height: 28px;
    width: 223px;
    margin-bottom: 12px;
    .textContainer {
      width: 223px;
    }
  }
  .godName {
    width: 263px;
    height: 53px;
    .textContainer {
      width: 263px;
    }
  }
  .gift {
    width: 178px;
    height: 32px;
    margin: 0 17px auto auto;
    .textContainer {
      width: 178px;
    }
  }
  .respect {
    width: 46px;
    position: absolute;
    bottom: 3px;
    left: 15px;
  }
}
</style>
